import * as constants from '../constants/poi';

const initialState = {
    pois: []
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.SET_POIS:
            return {
                ...state,
                pois: action.pois
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/poi.js